import React from 'react';
import { Box, CircularProgress, Dialog, DialogContent, DialogTitle } from '@mui/material';
import useLoaderSelector from '../store/Slice/Loader/LoaderSelector';

export default function CustomLoader() {
  const { isPageLoading } = useLoaderSelector() || {};
  return (
    <Box>
      <Dialog
        open={isPageLoading?.loading || false}
        className="loaderWrap"
        style={{ zIndex: '9999' }}
      >
        <DialogTitle className="loader-title">
          {/* {isPageLoading?.loadingMessage || 'Rohit wait!'} */}
          {isPageLoading?.loadingMessage || 'Please wait!'}
        </DialogTitle>
        <DialogContent className="loader-content">
          <Box className="loaderBar">
            <CircularProgress />
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
